/**
 * @author PoornaChandu
 * @description 
 */
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';
import TabPane from 'antd/lib/tabs/TabPane';
import Highlighter from 'react-highlight-words';
import { IPAddress } from '../../../../commons/api';
import localStorage from '../../../../utils/localStorage';
import { SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Input, Upload, message, Modal, Select, Form, Checkbox, Card, Tabs } from 'antd';
import { checkFileAlreadyExistsOrNot, getFileData1, getModList, getUsersList } from '../APICalls';
import { StyledHomepage } from '../../../../commons/styles/layout';
import StyledTable from '../../../../commons/styles/table';

const { Option } = Select;

const FileUpload = ({ translationCache }) => {
  const formRef = useRef();
  const [files, setFiles] = useState([]);
  const [image] = useState([]);
  const [viewModal, setViewModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [selectedModules, setSelectedModules] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [newImages, setNewImages] = useState([]);
  const [fileExist, setFileExist] = useState(false);

  useEffect(() => {
    _getUserList();
    getAttachmentList();
    getModulesList();
  }, []);

  const getModulesList = async () => {
    let moduleList = await getModList();
    setModuleList(moduleList);
  };

  const _getUserList = async () => {
    let userList = await getUsersList();
    setUserList(userList);
  };

  const getAttachmentList = async (selectedTabs) => {
    let files = await getFileData1(selectedTabs);
    setFiles(files);
  };

  const handleTabChange = (key) => {
    getAttachmentList(key);
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={translation('Search')}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}

          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleCancel = () => {
    setVisible(false);
  };

  const handleOk = () => {
    let { selectedModules } = this.state;
    setViewModal(false);
    setIsLoading(true);
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let url = `/api/chat/upload?SiteId=${siteId}&Module=${selectedModules}`;
    let formData = new FormData();
    let files = newImages[0];
    formData.append('file', files);
    formData.append('OverWrite', fileExist);
    let orgHeaders = {
      method: 'POST',
      url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: formData
    };
    axios(orgHeaders)
      .then((response) => {
        message.success('File embedded Successfully');
        setFiles(response.data);
        setIsLoading(false);
        getAttachmentList();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getUserName = (value) => {
    let userData = userList && Array.isArray(userList) && userList.filter((user) => user.Id === value);
    return userData && userData[0] && userData[0].FirstName ? userData[0].FirstName : value;
  };

  // const beforeUpload = async (uploadedFile) => {
  //   let payload = { FileName: uploadedFile.name };
  //   let fileExist = await checkFileAlreadyExistsOrNot(payload);
  //   if (fileExist.FileStatus !== 'false') {
  //     let newImages = [...image];
  //     newImages.push(uploadedFile);
  //     setViewModal(true);
  //     setNewImages(newImages);
  //     setFileExist(fileExist.FileStatus);
  //   } else {
  //     return true;
  //   }
  //   return false;
  // };

  const customRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess(file);
      message.success(`${file.name} file embedded successfully.`);
    }, 1000);
  };

  const handleChange = (info) => {
    setFileList(info.fileList);
  };

  const handleUploadClick = () => {
    setVisible(true);
  };

  const handleSubmit = (values) => {
    if (fileList.length === 0) {
      message.error('Please select a file before submitting.');
      return;
    }

    setIsLoading(true);

    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');

    const encodedModules = encodeURIComponent(selectedModules);

    let url = `/api/chat/upload?SiteId=${siteId}&Module=${encodedModules}&image_extrct=${values.image_extrct}&header_txt=${values.header_txt}&footer_txt=${values.footer_txt}&keyword=${values.keyword}`;

    let formData = new FormData();
    let fileToUpload = fileList[0].originFileObj;

    formData.append('image_extrct', values.image_extrct);
    formData.append('header_txt', values.header_txt);
    formData.append('footer_txt', values.footer_txt);
    formData.append('keyword', values.keyword);
    formData.append('OverWrite', 'false');
    formData.append('file', fileToUpload);

    axios.post(url, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
      .then(() => {
        setIsLoading(false);
        message.success('File uploaded successfully');
        setFileList([]);
        getAttachmentList();
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
        message.error('File upload failed.');
      });
  };

  const handleFileUpload = async (uploadedFile) => {
    const { selectedModules } = this.state;
    if (!selectedModules || selectedModules.length === 0) {
      message.error('Please select at least one module before uploading a file!');
      return false;
    }
    let payload = { FileName: uploadedFile.name };
    let fileExist = await checkFileAlreadyExistsOrNot(payload);
    if (fileExist.FileStatus !== 'false') {
      let newImages = [...image];
      newImages.push(uploadedFile);
      setViewModal(true);
      setNewImages(newImages);
      setVisible(false);
      setFileExist(fileExist.FileStatus);
      return false;
    } else {
      return true;
    }
  };

  const handleDropdownChange = (selectedModules) => {
    setSelectedModules(selectedModules);
  };

  const handleCancelModal = () => {
    setViewModal(false);
  };

  const columns = [
    {
      title: translation('File Name'),
      dataIndex: 'FileName',
      key: 'FileName',
      ...getColumnSearchProps('FileName'),
      render: (text, record) => (
        <a
          href={`${IPAddress.LOCAL}/api/${record.FilePath}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {text}
        </a>
      )
    },
    {
      title: translation('Attachment Type'),
      dataIndex: 'AttachmentType',
      key: 'AttachmentType'
    },
    {
      title: translation('Created By'),
      dataIndex: 'UploadedBy',
      key: 'UploadedBy',
      render: (text) => <>{text ? getUserName(text) : text}</>
    },
    {
      title: translation('Created Date'),
      dataIndex: 'UploadedDate',
      key: 'UploadedDate',
      render: (text) => <>{text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : text}</>
    }
  ];

  return (
    <StyledHomepage>
      <div style={{ margin: '20px' }}>
        <Button icon={<UploadOutlined />} onClick={handleUploadClick}>
          Upload a File
        </Button>
        <Modal
          title="File Upload"
          open={visible}
          onCancel={handleCancel}
          footer={null}
        >
          <Form ref={formRef} layout="vertical" onFinish={handleSubmit}>
            <Card title="Module and File Selection" style={{ marginBottom: 16 }}>
              <Form.Item
                label="Select Module"
                name="selectedModules"
                rules={[{ required: true, message: 'Please Select At least one Module!' }]}
              >
                <Select
                  mode="multiple"
                  placeholder="Select Module"
                  showSearch
                  onChange={handleDropdownChange}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {moduleList.map((mod) => (
                    <Option key={mod.key} value={mod.Value}>
                      {mod.Key}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Upload File"
                name="file"
                rules={[{ required: true, message: 'Please Upload a file' }]}
              >
                <Upload
                  showUploadList={true}
                  fileList={fileList}
                  customRequest={customRequest}
                  beforeUpload={handleFileUpload}
                  onChange={handleChange}
                  disabled={!selectedModules || selectedModules.length === 0}
                >
                  <Button
                    icon={<UploadOutlined />}
                    disabled={!selectedModules || selectedModules.length === 0}
                  >
                    Upload File
                  </Button>
                </Upload>
              </Form.Item>
            </Card>

            <Card title="Additional Configuration" style={{ marginBottom: 16 }}>
              <Form.Item label="Images Extraction" name="image_extrct" valuePropName="checked">
                <Checkbox>Enable</Checkbox>
              </Form.Item>

              <Form.Item label="Header Text" name="header_txt">
                <Input
                  placeholder="Enter Header Text"
                  disabled={!selectedModules || selectedModules.length === 0}
                />
              </Form.Item>

              <Form.Item label="Footer Text" name="footer_txt">
                <Input
                  placeholder="Enter Footer Text"
                  disabled={!selectedModules || selectedModules.length === 0}
                />
              </Form.Item>

              <Form.Item label="Tables Keyword" name="keyword">
                <Input
                  placeholder="Enter Keyword for Combining Tables"
                  disabled={!selectedModules || selectedModules.length === 0}
                />
              </Form.Item>
            </Card>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                disabled={!selectedModules || selectedModules.length === 0}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Modal>
        <Modal open={viewModal} footer={null}>
          <div>
            <p>Do you want to overwrite the existing file??</p>
            <div style={{ marginTop: '5%' }}>
              <Button onClick={handleOk}>{'Yes'}</Button>
              <Button style={{ marginLeft: '2%' }} onClick={handleCancelModal}>
                {'No'}
              </Button>
            </div>
          </div>
        </Modal>
        <Tabs type="card" defaultActiveKey="ChatGPT" onChange={handleTabChange}>
          <TabPane tab="ChatGPT" key="ChatGPT">
            <StyledTable
              size="small"
              style={{ marginTop: '20px' }}
              columns={columns}
              dataSource={files}
              scroll={{ x: 1000, y: 1000 }}
              loading={isLoading}
            />
          </TabPane>
          <TabPane tab="RuleEngine" key="RuleEngine">
            <StyledTable size="small"
              style={{ marginTop: '20px' }}
              columns={columns}
              dataSource={files}
              scroll={{ x: 1000, y: 1000 }}
              loading={isLoading}
            />
          </TabPane>
          <TabPane tab="FaultAnalysis" key="FaultAnalysis">
            <StyledTable size="small"
              style={{ marginTop: '20px' }}
              columns={columns}
              dataSource={files}
              scroll={{ x: 1000, y: 1000 }}
              loading={isLoading}
            />
          </TabPane>
        </Tabs>
      </div>
    </StyledHomepage>
  );
};
const mapStateToProps = (state) => {
  return {
    userProfile: state.LayoutReducer.getUserProfile,
    translationCache: state.TranslationReducer.translationCache,
  };
};


export default connect(mapStateToProps)(FileUpload);